/* Night Care Tech — shared behavior for the bottle-warmer landing.
   Used identically by theme/sections/bonitale-bottle-warmer.liquid and preview/index.html.
   No quantity selector and no /cart/add.js calls: purchase runs entirely
   through the Releasit COD Form app (hook div + its own generated button). */
(function () {
  "use strict";

  function init(root) {
    document.body.classList.add("ncw-landing-active");
    initReleasitOffer(root);
    initReleasitButtonCopy();
    initGallery(root);
    initStickyCta(root);
    initDemoVideo(root);
    initCodProxy(root);
    initSocialProof(root);
  }

  // Releasit has a product-specific bottle-warmer offer. An older 25% group was
  // also associated at runtime and won by array order, so remove this product
  // from every other group and complete the intended 1/2/3-unit offer.
  function initReleasitOffer(root) {
    var productId = root.getAttribute("data-product-id");
    var groups = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!productId || !Array.isArray(groups)) return;

    var target = groups.find(function (group) {
      if (!group || !group.isActive || !Array.isArray(group.pIds) || group.pIds.indexOf(productId) === -1) return false;
      if (group.name === "Calentador de Teteros") return true;
      return Array.isArray(group.offers) && group.offers.some(function (offer) {
        return offer.qty === 2 && offer.ds && offer.ds.t === "fixed" && offer.ds.v === 2990000;
      });
    });

    if (!target) return;

    groups.forEach(function (group) {
      if (group === target || !Array.isArray(group.pIds)) return;
      group.pIds = group.pIds.filter(function (id) { return id !== productId; });
    });

    // Deep purchase-orange: stronger visual salience than the former pastel
    // orange and 5.18:1 contrast with white plaque/badge text.
    var orange = "rgba(194,65,12,1)";
    var imageTwo = root.getAttribute("data-offer-image-two") || "";
    var imageThree = root.getAttribute("data-offer-image-three") || "";
    var badgeBase = { badgeContent: "🔥 Mejor Oferta", badgeBgC: orange, badgeTC: "rgba(255,255,255,1)", badgeBR: 12, animation: "none", textAlign: "left" };
    var current = Array.isArray(target.offers) ? target.offers : [];
    var one = Object.assign({}, current[0] || {}, {
      pos: 0, title: "1 Calentador de teteros", qty: 1,
      ds: { t: "none", v: 0 }, pres: false, plaque: "Ahorra 45%",
      plaqueBgC: orange, plaqueTC: "rgba(255,255,255,1)",
      bestDealBadge: Object.assign({}, badgeBase, { show: false })
    });
    var two = Object.assign({}, current[1] || {}, {
      pos: 1, title: "2 Calentadores de teteros", qty: 2,
      ds: { t: "fixed", v: 3710000 }, pres: false, plaque: "Ahorras $160.000",
      imgUrl: imageTwo,
      plaqueBgC: orange, plaqueTC: "rgba(255,255,255,1)",
      bestDealBadge: Object.assign({}, badgeBase, { show: false })
    });
    var three = Object.assign({}, current[2] || current[1] || {}, {
      pos: 2, title: "3 Calentadores de teteros", qty: 3,
      ds: { t: "fixed", v: 7360000 }, pres: true, plaque: "Ahorras $250.000",
      imgUrl: imageThree,
      plaqueBgC: orange, plaqueTC: "rgba(255,255,255,1)",
      bestDealBadge: Object.assign({}, badgeBase, { show: true })
    });

    target.offers = [one, two, three];
    target.selBC = orange;
    target.selBgC = "rgba(255,243,224,1)";
    target.borderRadius = 8;
    target.useComparePrice = true;
    target.hideImg = false;
  }

  function initReleasitButtonCopy() {
    function polish() {
      var subtitle = document.querySelector("._rsi-buy-now-button-subtitle");
      if (subtitle) subtitle.textContent = "Haz clic aquí para ver las ofertas";
      return !!subtitle;
    }

    if (polish()) return;
    var observer = new MutationObserver(function () {
      if (polish()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initGallery(root) {
    var galleries = root.querySelectorAll(".gallery");
    galleries.forEach(function (gallery) {
      var track = gallery.querySelector(".gallery-track");
      var slides = Array.prototype.slice.call(gallery.querySelectorAll(".gallery-slide"));
      var navButtons = Array.prototype.slice.call(gallery.querySelectorAll(".gallery-nav-btn"));
      if (!track || slides.length < 2) return;

      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var desktopQuery = window.matchMedia ? window.matchMedia("(min-width: 960px)") : null;
      var observer = null;

      function setActive(index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === index);
        });
        navButtons.forEach(function (btn, i) {
          btn.setAttribute("aria-selected", i === index ? "true" : "false");
        });
      }

      function isDesktop() {
        return !!(desktopQuery && desktopQuery.matches);
      }

      // The swipe observer only runs in mobile mode, where the track actually
      // scrolls. On desktop all slides share the same absolutely-positioned
      // rect (stacked, toggled by opacity), so every slide would report as
      // simultaneously intersecting and fight over which one is "active".
      function attachSwipeObserver() {
        if (observer || !("IntersectionObserver" in window)) return;
        observer = new IntersectionObserver(
          function (entries) {
            var best = null;
            entries.forEach(function (entry) {
              if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
                best = entry;
              }
            });
            if (best) {
              var index = slides.indexOf(best.target);
              if (index !== -1) setActive(index);
            }
          },
          { root: track, threshold: [0.6] }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      function detachSwipeObserver() {
        if (!observer) return;
        observer.disconnect();
        observer = null;
      }

      function syncMode() {
        if (isDesktop()) {
          detachSwipeObserver();
        } else {
          attachSwipeObserver();
        }
      }

      navButtons.forEach(function (btn, i) {
        btn.addEventListener("click", function () {
          if (isDesktop()) {
            setActive(i);
          } else {
            slides[i].scrollIntoView({
              behavior: reduceMotion ? "auto" : "smooth",
              inline: "start",
              block: "nearest"
            });
          }
        });
      });

      setActive(0);
      syncMode();

      if (desktopQuery) {
        var onChange = function () { syncMode(); };
        if (desktopQuery.addEventListener) desktopQuery.addEventListener("change", onChange);
        else if (desktopQuery.addListener) desktopQuery.addListener(onChange);
      }
    });
  }

  function initStickyCta(root) {
    var sticky = root.querySelector(".sticky-cta");
    var sentinel = root.querySelector(".ladder-section");
    if (!sticky || !sentinel) return;

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // The Interest section begins immediately after the purchase panel.
            // This distinguishes "still below the fold" from "already passed"
            // even when the page jumps several viewports in one frame.
            sticky.classList.toggle(
              "is-visible",
              entry.isIntersecting || entry.boundingClientRect.top < 0
            );
          });
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      sticky.classList.add("is-visible");
    }
  }

  function initDemoVideo(root) {
    var frame = root.querySelector(".demo-frame");
    if (!frame) return;
    var video = frame.querySelector("video");
    var button = frame.querySelector(".demo-play");
    if (!video || !button) return;

    button.addEventListener("click", function () {
      video.play();
      frame.classList.add("is-playing");
    });

    video.addEventListener("pause", function () {
      frame.classList.remove("is-playing");
    });
    video.addEventListener("ended", function () {
      frame.classList.remove("is-playing");
    });
  }

  // Proxies clicks to the button Releasit COD Form generates. Until that app
  // script has mounted, falls back to scrolling/focusing the COD form region so
  // the real trigger is always reachable — never submits our own cart request.
  function initCodProxy(root) {
    var proxyButtons = root.querySelectorAll("[data-cod-proxy]");
    if (!proxyButtons.length) return;

    function activateReleasit() {
      var realButton = document.querySelector("#_rsi-buy-now-button, ._rsi-buy-now-button");
      if (realButton) {
        realButton.click();
        return;
      }
      var hook = root.querySelector(".cod-hook");
      if (hook) {
        hook.scrollIntoView({ behavior: "smooth", block: "center" });
        if (!hook.hasAttribute("tabindex")) hook.setAttribute("tabindex", "-1");
        hook.focus({ preventScroll: true });
      }
    }

    proxyButtons.forEach(function (button) {
      button.addEventListener("click", activateReleasit);
    });
  }

  // Judge.me may leave an empty app container even with
  // empty_state=hide_widget. Hide the complete proof section until actual
  // review cards are mounted, then reveal it if reviews arrive asynchronously.
  function initSocialProof(root) {
    var section = root.querySelector(".social-proof-section");
    if (!section) return;
    var widgetHost = section.querySelector(".social-proof-widget");
    if (!widgetHost) return;

    function syncVisibility() {
      section.hidden = !widgetHost.querySelector(".jdgm-rev");
    }

    syncVisibility();
    if ("MutationObserver" in window) {
      new MutationObserver(syncVisibility).observe(widgetHost, {
        childList: true,
        subtree: true
      });
    }
  }

  // Shopify sections can't edit <head>; inject a description only if the
  // theme/layout didn't already provide one, so Lighthouse SEO passes without
  // touching global layout markup.
  function ensureMetaDescription() {
    if (document.querySelector('meta[name="description"]')) return;
    var meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    meta.setAttribute(
      "content",
      "Calentador portátil de teteros Bonitale para preparar la próxima toma lejos de la cocina, durante la noche o fuera de casa."
    );
    document.head.appendChild(meta);
  }

  function boot() {
    ensureMetaDescription();
    document.querySelectorAll(".ncw").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
